import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import React, { useContext } from 'react';
import classnames from 'classnames';
import Month from './panel/month/month';
import Year from './panel/year/year';
import Quarter from './panel/quarter/quarter';
import Calendar from './calendar';
import Time from './panel/time/time';
import Context from './context';
import Header from './panel/header/header';
import { addMonths, addYears, getMonth, getYear, getYearsPeriod, DEFAULT_YEAR_ITEM_NUMBER } from './utils/date-fns';
import { getClosingViewDate, getTimeProps } from './utils';
import isBoolean from 'lodash/isBoolean';
import DateTime from './panel/date-time/date-time';
function Panel(props) {
  var context = useContext(Context);
  var prefixCls = context.prefixCls,
    viewDate = context.viewDate,
    setViewDate = context.setViewDate,
    panelPosition = context.panelPosition,
    locale = context.locale,
    innerPicker = context.innerPicker,
    setInnerPicker = context.setInnerPicker;
  var isInnerPicker = innerPicker !== undefined;
  var isPositionLeft = panelPosition === 'left';
  var isPositionRight = panelPosition === 'right';
  var isPositionUnset = typeof panelPosition === 'undefined';
  var _props$picker = props.picker,
    picker = _props$picker === void 0 ? 'date' : _props$picker,
    format = props.format,
    showTime = props.showTime,
    mergedActivePickerIndex = props.mergedActivePickerIndex,
    useWeekdaysShort = props.useWeekdaysShort,
    showWeekNumber = props.showWeekNumber,
    showWeeksTitle = props.showWeeksTitle,
    disabledDate = props.disabledDate;
  var getHeader = function getHeader() {
    return /*#__PURE__*/React.createElement(Header, _extends({}, headerProps, {
      className: headerObj.className
    }), headerObj.children);
  };
  var renderYearPanel = function renderYearPanel() {
    var _props$yearItemNumber = props.yearItemNumber,
      yearItemNumber = _props$yearItemNumber === void 0 ? DEFAULT_YEAR_ITEM_NUMBER : _props$yearItemNumber;
    return /*#__PURE__*/React.createElement(Year, _extends({}, props, {
      yearItemNumber: yearItemNumber
    }));
  };
  var renderMonthPanel = function renderMonthPanel() {
    return /*#__PURE__*/React.createElement(Month, _extends({}, props));
  };
  var renderQuarterPanel = function renderQuarterPanel() {
    return /*#__PURE__*/React.createElement(Quarter, _extends({}, props));
  };
  var renderDatePanel = function renderDatePanel() {
    if (isInnerPicker) {
      if (innerPicker === 'year') {
        return renderYearPanel();
      } else {
        return renderMonthPanel();
      }
    }
    if (!showTime) {
      var dateProps = {
        picker: picker,
        useWeekdaysShort: useWeekdaysShort,
        showWeekNumber: showWeekNumber,
        showWeeksTitle: showWeeksTitle,
        disabledDate: disabledDate
      };
      return /*#__PURE__*/React.createElement(Calendar, _extends({}, dateProps, {
        picker: picker
      }));
    } else {
      var _props = _extends(_extends(_extends({}, props), showTime && !isBoolean(showTime) ? getTimeProps(_extends(_extends({
        format: format
      }, showTime), {
        picker: picker
      })) : {}), picker === 'time' ? getTimeProps(_extends(_extends({
        format: format
      }, props), {
        picker: picker
      })) : {});
      return /*#__PURE__*/React.createElement(DateTime, _extends({}, _props, {
        picker: picker,
        dateHeader: getHeader()
      }));
    }
  };
  var renderTimePanel = function renderTimePanel() {
    var _props = _extends(_extends(_extends(_extends({}, props), {
      format: undefined
    }), showTime && !isBoolean(showTime) ? getTimeProps(_extends(_extends({
      format: format
    }, showTime), {
      picker: picker
    })) : {}), picker === 'time' ? getTimeProps(_extends(_extends({
      format: format
    }, props), {
      picker: picker
    })) : {});
    return /*#__PURE__*/React.createElement(Time, _extends({}, _props));
  };
  var renderYearHeader = function renderYearHeader() {
    var _props$yearItemNumber2 = props.yearItemNumber,
      yearItemNumber = _props$yearItemNumber2 === void 0 ? DEFAULT_YEAR_ITEM_NUMBER : _props$yearItemNumber2;
    var _getYearsPeriod = getYearsPeriod(viewDate, yearItemNumber),
      startPeriod = _getYearsPeriod.startPeriod,
      endPeriod = _getYearsPeriod.endPeriod;
    var headerCls = classnames("".concat(prefixCls, "-header"), "".concat(prefixCls, "-header-year"));
    return {
      children: /*#__PURE__*/React.createElement(React.Fragment, null, startPeriod, " - ", endPeriod),
      className: headerCls
    };
  };
  var renderMonthHeader = function renderMonthHeader() {
    var year = getYear(viewDate);
    var headerCls = classnames("".concat(prefixCls, "-header"), "".concat(prefixCls, "-header-month"));
    return {
      children: /*#__PURE__*/React.createElement(React.Fragment, null, year + locale.year),
      className: headerCls
    };
  };
  var onHeaderYearClick = function onHeaderYearClick() {
    if (picker === 'date') {
      setInnerPicker('year');
    }
  };
  var onHeaderMonthClick = function onHeaderMonthClick() {
    if (picker === 'date') {
      setInnerPicker('month');
    }
  };
  var renderDateHeader = function renderDateHeader() {
    var _classnames, _classnames2;
    var year = getYear(viewDate);
    var month = getMonth(viewDate) + 1;
    var headerCls = classnames("".concat(prefixCls, "-header"), "".concat(prefixCls, "-header-date"));
    return {
      children: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: classnames("".concat(prefixCls, "-header-text-inner"), (_classnames = {}, _defineProperty(_classnames, "".concat(prefixCls, "-header-text-inner-active"), innerPicker === 'year'), _defineProperty(_classnames, "".concat(prefixCls, "-header-text-inner-hover"), picker === 'date'), _classnames)),
        onClick: onHeaderYearClick
      }, year + locale.year), /*#__PURE__*/React.createElement("span", {
        className: classnames("".concat(prefixCls, "-header-text-inner"), (_classnames2 = {}, _defineProperty(_classnames2, "".concat(prefixCls, "-header-text-inner-active"), innerPicker === 'month'), _defineProperty(_classnames2, "".concat(prefixCls, "-header-text-inner-hover"), picker === 'date'), _classnames2)),
        onClick: onHeaderMonthClick
      }, month + locale.month)),
      className: headerCls
    };
  };
  var onSuperPrev = function onSuperPrev() {
    var date;
    if (picker === 'year' || innerPicker === 'year') {
      var _props$yearItemNumber3 = props.yearItemNumber,
        yearItemNumber = _props$yearItemNumber3 === void 0 ? DEFAULT_YEAR_ITEM_NUMBER : _props$yearItemNumber3;
      date = addYears(viewDate, 0 - yearItemNumber);
    } else {
      date = addYears(viewDate, -1);
    }
    setViewDate(date, mergedActivePickerIndex);
  };
  var onSuperNext = function onSuperNext() {
    var date;
    if (picker === 'year' || innerPicker === 'year') {
      var _props$yearItemNumber4 = props.yearItemNumber,
        yearItemNumber = _props$yearItemNumber4 === void 0 ? DEFAULT_YEAR_ITEM_NUMBER : _props$yearItemNumber4;
      var _viewDate = viewDate;
      if (panelPosition) {
        _viewDate = getClosingViewDate(viewDate, picker, -1, yearItemNumber);
      }
      date = addYears(_viewDate, yearItemNumber);
    } else {
      var _viewDate2 = viewDate;
      if (panelPosition) {
        _viewDate2 = getClosingViewDate(viewDate, picker, -1);
      }
      date = addYears(_viewDate2, 1);
    }
    setViewDate(date, mergedActivePickerIndex);
  };
  var onPrev = function onPrev() {
    var date = addMonths(viewDate, -1);
    setViewDate(date, mergedActivePickerIndex);
  };
  var onNext = function onNext() {
    var date = addMonths(viewDate, 1);
    setViewDate(date, mergedActivePickerIndex);
  };
  var panel;
  var headerProps = {};
  var headerObj;
  switch (picker) {
    case 'year':
      {
        panel = renderYearPanel();
        headerObj = renderYearHeader();
        headerProps = {
          onSuperPrev: isPositionRight ? undefined : onSuperPrev,
          onSuperNext: isPositionLeft ? undefined : onSuperNext
        };
        break;
      }
    case 'month':
      {
        panel = renderMonthPanel();
        headerObj = renderMonthHeader();
        headerProps = {
          onSuperPrev: isPositionRight ? undefined : onSuperPrev,
          onSuperNext: isPositionLeft ? undefined : onSuperNext
        };
        break;
      }
    case 'quarter':
      {
        panel = renderQuarterPanel();
        headerObj = renderMonthHeader();
        headerProps = {
          onSuperPrev: isPositionRight ? undefined : onSuperPrev,
          onSuperNext: isPositionLeft ? undefined : onSuperNext
        };
        break;
      }
    // 时间面板，4个箭头的显隐，在时间范围时需要判断是否在快捷选择面板下
    case 'date':
      {
        headerObj = renderDateHeader();
        headerProps = {
          onPrev: isPositionLeft && !isInnerPicker || innerPicker === 'month' || isPositionUnset ? onPrev : undefined,
          onNext: isPositionRight && !isInnerPicker || innerPicker === 'month' || isPositionUnset ? onNext : undefined,
          onSuperPrev: isPositionLeft && !isInnerPicker || innerPicker === 'year' || isPositionUnset ? onSuperPrev : undefined,
          onSuperNext: isPositionRight && !isInnerPicker || innerPicker === 'year' || isPositionUnset ? onSuperNext : undefined
        };
        panel = renderDatePanel();
        break;
      }
    case 'week':
      {
        panel = renderDatePanel();
        headerObj = renderDateHeader();
        headerProps = {
          onPrev: isPositionRight ? undefined : onPrev,
          onNext: isPositionLeft ? undefined : onNext,
          onSuperPrev: isPositionRight ? undefined : onSuperPrev,
          onSuperNext: isPositionLeft ? undefined : onSuperNext
        };
        break;
      }
    case 'time':
      {
        panel = renderTimePanel();
        break;
      }
    default:
      {
        break;
      }
  }
  var showHeader = !(picker === 'date' && showTime || picker === 'time') || innerPicker !== undefined;
  var containerCls = classnames("".concat(prefixCls, "-warpper"));
  return /*#__PURE__*/React.createElement("div", {
    className: containerCls
  }, showHeader ? getHeader() : null, panel);
}
export default Panel;